<template>
  <!-- Establece la altura al 100% de la ventana -->
    <div style="height: 50vh;"> 
  <LineChartGenerator v-if="chartData" 
  :chart-options="computed_chart_options"
  style="height: 100%;"

  :chartData="chartData" ref="canvas" />
    </div>
</template>

<script>
// import { Line as LineChartGenerator,mixins } from 'vue-chartjs/legacy'
import { Line as LineChartGenerator } from 'vue-chartjs'

import zoomPlugin from 'chartjs-plugin-zoom';
import annotationPlugin from 'chartjs-plugin-annotation';


import {
  Chart as ChartJS,
  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
  Legend
} from 'chart.js'

ChartJS.register(
  Legend,
  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  zoomPlugin,
  annotationPlugin,
  CategoryScale)

export default {
  name: 'LineChart',
  components: {
    LineChartGenerator
  },
  props: {
    unidades: String,
    setpointMaximo:Number,
    receta:Array,
    chartData: Object,
    plugins: {
      type: Array,
      default: () => []
    }
  },
  methods: {
  },
  mounted() {
    if(this.receta && this.$route.name != 'datalogger'){

      console.log('receta',this.receta)
      // Utilizando reduce para encontrar el setpoint máximo
      const setpointMaximo = this.receta.reduce((maximo, objeto) => {
        return objeto.setpoint > maximo ? objeto.setpoint : maximo;
      }, Number.NEGATIVE_INFINITY);
      this.chartOptions.scales.y.suggestedMax=setpointMaximo+10
    }
  },
  
  computed:{
    computed_chart_options(){
      let CurrentChartOptions=this.chartOptions;
      if(this.receta && this.$route.name != 'datalogger'){
        const setpointMaximo = this.receta.reduce((maximo, objeto) => {
        return objeto.setpoint > maximo ? objeto.setpoint : maximo;
      }, Number.NEGATIVE_INFINITY);
      CurrentChartOptions.scales.y.suggestedMax=setpointMaximo+10
    }
      return CurrentChartOptions;
    }
  },

  data() {
    const self = this; // Guardamos una referencia al contexto actual (this)


    return {

      chartOptions: {
        responsive: true,
        animation: false, // Desactivar animación
        maintainAspectRatio: false,

        legend: {
          display: false,
          position: 'bottom', // Posición de la leyenda (top, bottom, left, right)
          labels: {
            fontColor: 'black', // Color del texto de la leyenda
          },
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let label = this.chartData.datasets[tooltipItem.datasetIndex].label || '';
              if (label) {
                label += ':ssss ';
              }
              label += tooltipItem.yLabel;
              return 'label';
            }
          }
        },

       
        scales: {
          y: {
            // ticks: {
              
            //   stepSize: 1,
            //   callback: function (value, index) {

            //     return value
            //   }
            // },
            suggestedMin: 0,
            suggestedMax: 0
            // min: 0,
            // max: 400,
          },

          // yAxes: [{
          //   ticks: {
          //     beginAtZero: true,

          //   },
          // }],
        },
        interaction: {
          mode: 'index',
          intersect: false,
        },
        // Dentro del método onHover
        onHover: function (event, chartElement) {
          if (chartElement.length > 0) {
         
            let miCanvas = self.$refs.canvas.$el.querySelector('canvas');
            // let miCanvas = self.$refs.canvas.$el;
          
            const elemento = chartElement[0];
            const mouseX = elemento.element.x;
          
            // // // // Obteniendo el contexto del canvas
            const ctx = miCanvas.getContext('2d');

            // Dibujar la línea vertical
            ctx.beginPath();
            ctx.moveTo(mouseX, 0);
            ctx.strokeStyle = '#000';
            ctx.lineWidth = 1;
            ctx.lineTo(mouseX, miCanvas.height);
            ctx.stroke();

          }
        },





      },
    }
  }
}
</script>
